import React, { memo } from 'react';

import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';
import { convertNumbersToProperFormat } from 'utils/number';

const MainProgressPart: React.FC<
  IPrintPartProps<'mainProgress' | 'secondaryProgress'>
> = ({
  taskId,
  property,
  item: {
    options: { view },
    part,
  },
}) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { company, allTasks } = dataContext;

      const showBothKeyValue = view === 'both';
      let showKey = showBothKeyValue;
      let showValue = showBothKeyValue;

      if (!showBothKeyValue) {
        showKey = view === 'key';
        showValue = view === 'value';
      }

      let progressTitle;
      let progressValue;

      if (showKey) {
        const templateId = allTasks!.find(
          (task) => task.id === taskId
        )!.templateId;
        const companyTemplate = company?.templates?.find(
          (template) => template.taskId === templateId
        );
        progressTitle = messages.getMainProgressTitle(
          companyTemplate!.task!.templateReportOptions![
            part === 'mainProgress'
              ? 'mainProgressTitle'
              : 'secondaryProgressTitle'
          ]
        );
      }
      if (showValue) {
        progressValue = property;
      }

      return (
        <SingleTaskPart>
          <span>{showKey && progressTitle}</span>
          <span>
            {showValue && progressValue
              ? messages.getMainProgressValue(
                  convertNumbersToProperFormat(progressValue as number)
                )
              : '-'}
          </span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(MainProgressPart);
